module.exports = __webpack_public_path__ + "img/campic.167448ce.png";